import React from 'react';
import { Outlet } from 'react-router-dom';

const BasicSubscriptionRouter: React.FC = () => {
  return <Outlet />;
};

export default BasicSubscriptionRouter;
